var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"wysiwyg-container container p-4 lg:p-30px",class:_vm.item.container_class},[_c('wysiwyg',{attrs:{"item":_vm.item.content,"tag-filter":_vm.styleTag}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }